module.exports = __webpack_public_path__ + "img/insurance.0157bb4e.jpg";